/* Bag: "Added to your bag" panel after Add to cart, and in-place quantity changes on the bag page.
   Progressive enhancement: without this file product forms post normally and the bag page uses its own form. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return 'A$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  var live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 50);
  }

  /* ---------- Header bag count ---------- */
  function setCount(count) {
    document.querySelectorAll('.cart-link').forEach(function (link) {
      var badge = link.querySelector('.cart-link__count');
      if (count > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'cart-link__count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      if (badge) {
        if (count > 0) badge.textContent = count; else badge.remove();
        badge.classList.remove('is-bump');
        void badge.offsetWidth;          // restart the bump animation
        badge.classList.add('is-bump');
      }
      var one = link.getAttribute('data-label-one'), other = link.getAttribute('data-label-other');
      if (one && other) link.setAttribute('aria-label', (count === 1 ? one : other).replace('[count]', count));
    });
  }

  /* ---------- Added-to-bag panel ---------- */
  var drawer = null;

  function openDrawer() {
    if (typeof drawer.showModal !== 'function') return;
    if (!drawer.open) drawer.showModal();
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }

  function closeDrawer() {
    if (!drawer.open) return;
    drawer.classList.remove('is-open');
    var done = function () { drawer.close(); };
    var motion = document.documentElement.classList.contains('motion-ok');
    if (motion) window.setTimeout(done, 280); else done();
  }

  function fillDrawer(item, cart) {
    var img = drawer.querySelector('[data-drawer-img]');
    if (img) img.src = item.image || drawer.getAttribute('data-render');
    drawer.querySelector('[data-drawer-name]').textContent = item.product_title;
    var meta = item.quantity > 1 ? item.quantity + ' × ' + money(item.final_price) : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
    drawer.querySelector('[data-drawer-meta]').textContent = meta;
    drawer.querySelector('[data-drawer-price]').textContent = money(item.final_line_price);
    drawer.querySelector('[data-drawer-count]').textContent = drawer.getAttribute(cart.item_count === 1 ? 'data-count-one' : 'data-count-other').replace('[count]', cart.item_count);
    drawer.querySelector('[data-drawer-subtotal]').textContent = money(cart.total_price);
    fillShipping(cart.item_count);
  }

  /* Shipping row and "add one more" line, from the theme's shipping settings. */
  function fillShipping(count) {
    var cell = drawer.querySelector('[data-drawer-shipping]');
    var nudge = drawer.querySelector('[data-drawer-nudge]');
    if (!cell) return;
    var from = parseInt(cell.getAttribute('data-free-from'), 10) || 0;
    var free = from > 0 && count >= from;
    cell.textContent = '';
    if (free) {
      var strong = document.createElement('strong');
      strong.className = 'bag__free';
      strong.textContent = cell.getAttribute('data-free');
      cell.appendChild(strong);
    } else {
      cell.textContent = cell.getAttribute('data-rate') || cell.getAttribute('data-at-checkout');
    }
    if (!nudge) return;
    var left = from - count;
    nudge.hidden = from === 0;
    nudge.classList.toggle('is-free', free);
    nudge.querySelector('[data-drawer-nudge-text]').textContent = free ? nudge.getAttribute('data-reached')
      : left === 1 ? nudge.getAttribute('data-one') : nudge.getAttribute('data-other').replace('[count]', left);
  }

  function showError(form, button, message) {
    var host = button && button.closest('.buy__actions, .hero__buy, .buybar') || form;
    var note = host.querySelector('[data-add-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'add-error';
      note.setAttribute('role', 'alert');
      note.setAttribute('data-add-error', '');
      host.appendChild(note);
    }
    note.textContent = message;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!drawer || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var button = e.submitter || form.querySelector('[type="submit"]');
    if (button && button.name === 'checkout') return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    var label = button && (button.querySelector('[data-add-label]') || button);
    var original = label ? label.textContent : '';
    form.setAttribute('aria-busy', 'true');
    if (button) { button.classList.add('is-busy'); button.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = drawer.getAttribute('data-adding') || 'Adding…';
    var old = form.querySelector('[data-add-error]') || (button && button.parentNode.querySelector('[data-add-error]'));
    if (old) old.remove();

    var body = new FormData(form);
    if (button && button.form !== form && button.name) body.append(button.name, button.value || '');

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
      .then(function (added) {
        var item = added.items ? added.items[0] : added;
        return fetch(root + 'cart.js', { headers: JSON_HEADERS }).then(function (r) { return r.json(); }).then(function (cart) {
          var line = cart.items.filter(function (i) { return i.key === item.key; })[0] || item;
          fillDrawer(line, cart);
          setCount(cart.item_count);
          openDrawer();
          announce(drawer.querySelector('[data-drawer-heading]').textContent);
        });
      })
      .catch(function (err) {
        showError(form, button, (err && (err.description || err.message)) || drawer.getAttribute('data-error'));
      })
      .then(function () {
        form.removeAttribute('aria-busy');
        if (button) { button.classList.remove('is-busy'); button.removeAttribute('aria-disabled'); }
        if (label) label.textContent = original;
      });
  }

  function initDrawer() {
    drawer = document.querySelector('[data-bag-drawer]');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || (e.target.closest && e.target.closest('[data-drawer-close]'))) closeDrawer();
    });
    drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    document.addEventListener('submit', onSubmit);
  }

  /* ---------- Bag page: change quantities in place ---------- */
  var pending = null;

  function refreshBag(section, focusKey, focusRole) {
    var id = section.getAttribute('data-section-id');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bag]');
        if (!fresh) { window.location.reload(); return; }
        section.innerHTML = fresh.innerHTML;
        section.classList.remove('is-updating');
        var target = focusKey && section.querySelector('[data-key="' + focusKey + '"] ' + focusRole);
        (target || section.querySelector('h1')).focus({ preventScroll: true });
      });
  }

  function changeLine(section, key, qty, role) {
    section.classList.add('is-updating');
    fetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        var from = parseInt(section.getAttribute('data-free-from'), 10) || 0;
        var ship = from > 0 && cart.item_count >= from ? 0 : (parseInt(section.getAttribute('data-ship-cents'), 10) || 0);
        announce(cart.item_count === 0 ? section.getAttribute('data-empty') : section.getAttribute('data-updated').replace('[total]', money(cart.total_price + ship)));
        return refreshBag(section, qty > 0 ? key : null, role);
      })
      .catch(function () { window.location.reload(); });
  }

  function initBagPage() {
    document.addEventListener('click', function (e) {
      var section = e.target.closest && e.target.closest('[data-bag]');
      if (!section) return;
      var step = e.target.closest('[data-bag-step]');
      var remove = e.target.closest('[data-bag-remove]');
      if (!step && !remove) return;
      var line = e.target.closest('[data-key]');
      if (!line) return;
      e.preventDefault();
      var input = line.querySelector('[data-bag-qty]');
      var n = remove ? 0 : Math.max(0, Math.min(10, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-bag-step'), 10)));
      input.value = n;
      window.clearTimeout(pending);
      var role = step ? '[data-bag-step="' + step.getAttribute('data-bag-step') + '"]' : null;
      pending = window.setTimeout(function () { changeLine(section, line.getAttribute('data-key'), n, role); }, remove ? 0 : 350);
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-bag] [data-bag-qty]')) return;
      var line = e.target.closest('[data-key]');
      var n = Math.max(0, Math.min(10, parseInt(e.target.value, 10) || 0));
      changeLine(e.target.closest('[data-bag]'), line.getAttribute('data-key'), n, '[data-bag-qty]');
    });
  }

  function init() { initDrawer(); initBagPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
